export default __webpack_public_path__ + "static/media/eftykhar.8169ec92.png";